module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-valors-eco.84c80df2.svg";